import React from 'react';
import { getFileName } from '../../../helpers/FileCatching';
import * as classes from './TitleContent.module.scss';
import Lottie from 'react-lottie';
import GlobalData from '../../../data/global.js';
import MediaQuery from 'react-responsive';

function TitleContent({content,onLoad}) {

    const dynamicImage = {
        loop: true,
        autoplay: true, 
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
    };



    let mobileImage = {...dynamicImage, 
        path: GlobalData.AnimationAssetCDNPath+content.mobile
    }
    let tabletImage = {...dynamicImage, 
        path: GlobalData.AnimationAssetCDNPath+content.tablet
    }
    let desktopImage = {...dynamicImage, 
        path: GlobalData.AnimationAssetCDNPath+content.desktop
    }

    return (
        <div className={`${classes.TitleContent}`}>
            <MediaQuery maxWidth={classes.screenMdMax}>
                <Lottie
                    eventListeners={[
                        {
                        eventName: 'data_ready',
                        callback: () => onLoad(),
                        },
                    ]}
                    
                    options={mobileImage}
                />
            </MediaQuery>
            <MediaQuery minWidth={classes.screenMd} maxWidth={classes.screenLgMax}>
                <Lottie
                    eventListeners={[
                        {
                        eventName: 'data_ready',
                        callback: () => onLoad(),
                        },
                    ]}
                    
                    options={tabletImage}
                />
            </MediaQuery>
            <MediaQuery minWidth={classes.screenLg}>
                <Lottie
                    eventListeners={[
                        {
                        eventName: 'data_ready',
                        callback: () => onLoad(),
                        },
                    ]}
                    
                    options={desktopImage}
                />
            </MediaQuery>
        </div>
    );
}

export default TitleContent;